/* eslint-disable max-statements */
/* eslint-disable complexity */
import React, { useEffect, useState } from "react";
import styles from "./styles.css";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";

import Button from "../../../shared/button";
import CarHuddleInsuranceSecondFoldCard from "../../../shared/car-huddle-insurance-second-fold-card/component";
import CarHuddleInsuranceHowItWorks from "../../../shared/car-huddle-insurance-how-it-works/component";
import CarHuddleInsuranceReviewRatingCard from "../../../shared/car-huddle-insurance-review-rating-card/component";
import CarHuddleInsuranceCustomerCare from "../../../shared/car-huddle-insurance-customer-care/component";

import { getMyBookingCarDetailsURL } from "../../../../utils/helpers/get-detail-page-url";
import { getCmsPageSection } from "../../../../utils/helpers/get-cms-page-section";
import CarHuddleInsuranceTopSection from "../../../shared/car-huddle-insurance-top-section/component";
import InsuranceCongratulationScreen from "../../../shared/insurance-congratulation-screen/component";
import { tasksRoutes } from "../../../../constants/au.mobile/tasks-routes";
import { trackMobileCustomEventsAU } from "../../../../tracking";
import { AU_MOBILE_EVENTS } from "../../../../tracking/au.mobile-events";
import { HUDDLE_STATUS } from "../constant";

const CarInsurance = ({
    appointmentId,
    orderId,
    cmsConfig,
    getInsuranceCmsConfigConnect,
    insuranceDetails,
    getInsuranceDetailsConnect,
    updatePostBcStepConnect,
    submitInsuranceDetailsConnect
}) => {
    const history = useHistory();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isInsuranceLoading, setIsInsuranceLoading] = useState(false);

    useEffect(() => {
        getInsuranceCmsConfigConnect("checkout-msite");
        if (orderId) {
            getInsuranceDetailsConnect(orderId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [orderId]);

    const insuranceDetailsData = insuranceDetails?.data || {};
    const huddleStatus = insuranceDetailsData?.status;

    const { pageSections = [] } = cmsConfig || {};
    const CAR_INSURANCE_WEBSITE = getCmsPageSection("CAR_INSURANCE_WEBSITE", pageSections);
    const { meta = {} } = CAR_INSURANCE_WEBSITE?.pageSection || {};
    const { insuranceLandingData = {}, purchasedInsuranceData = {}, notPurchasedInsuranceData = {} } = meta?.data || {};
    const huddleUSPs = insuranceLandingData.huddleUSPs || [];
    const pendingQuestionsStepsData = insuranceLandingData?.pendingQuestionsStepsData || {};
    const completedQuestionsStepsData = insuranceLandingData.completedQuestionsStepsData || {};
    const insurancePurchasedData = purchasedInsuranceData.bannerData || {};
    const reviewData = meta?.data?.reviewData || {};
    const contactUs = meta?.data?.contactUs || {};

    const isInsurancePurchased = huddleStatus === HUDDLE_STATUS.PURCHASED;
    const isInsuranceSubmitted = huddleStatus === HUDDLE_STATUS.SUBMITTED;
    const isInsuranceFailed = huddleStatus === HUDDLE_STATUS.FAILED;
    const isInsuranceInitiated = huddleStatus === HUDDLE_STATUS.INITIATED;
    const isInsuranceFormFilled = !insuranceDetailsData?.insuranceForm || insuranceDetailsData?.insuranceForm?.length === 0;

    const generateQuotes = async () => {
        if (isInsuranceFormFilled) {
            setIsModalOpen(true);
            setIsInsuranceLoading(true);
            try {
                await submitInsuranceDetailsConnect(orderId, insuranceDetailsData?.insuranceAnswers, true);
            } finally {
                setIsInsuranceLoading(false);
            }
        } else {
            trackMobileCustomEventsAU(AU_MOBILE_EVENTS.CAR_INSURANCE_CTA, { eventLabel: "Home_page_CTA" });
            const isFinanceFlow = window.location.pathname.includes("my-bookings-");
            if (isFinanceFlow) {
                const { relativeURL } = getMyBookingCarDetailsURL(appointmentId, tasksRoutes.carInsuranceApplication.route);
                history.replace(relativeURL);
            } else {
                const { relativeURL } = getMyBookingCarDetailsURL(appointmentId, tasksRoutes.carInsuranceApplication.route);
                history.replace(relativeURL);
            }
        }
    };
    const onSkipClick = (isFormFilled) => {
        const isFinanceFlow = window.location.pathname.includes("my-bookings-");
        if (isFinanceFlow) {
            const { relativeURL } = getMyBookingCarDetailsURL(appointmentId, tasksRoutes.viewTask.route);
            history.replace(relativeURL);
        } else {
            const { relativeURL } = getMyBookingCarDetailsURL(appointmentId, tasksRoutes.signContract.route);
            history.replace(relativeURL);
        }
        if (isFormFilled) {
            trackMobileCustomEventsAU(AU_MOBILE_EVENTS.CAR_INSURANCE_CTA, { eventLabel: "Return_home_page_CTA" });
        } else {
            trackMobileCustomEventsAU(AU_MOBILE_EVENTS.CAR_INSURANCE_CTA, { eventLabel: "Insurance_skipped" });
        }
        updatePostBcStepConnect({ orderId, step: "insurance" });
    };

    useEffect(() => {
        if (huddleStatus === null || huddleStatus === undefined) return;
        if (huddleStatus === HUDDLE_STATUS.INITIATED) {
            trackMobileCustomEventsAU(AU_MOBILE_EVENTS.CAR_INSURANCE_PAGE_LOADED, { eventLabel: "Home_page" });
        } else {
            trackMobileCustomEventsAU(AU_MOBILE_EVENTS.CAR_INSURANCE_PAGE_LOADED, { eventLabel: "Return_home_page" });
        }
    }, [huddleStatus]);

    return (
        <div styleName="styles.wrapper">
            <div styleName="styles.contentWrap">
                <CarHuddleInsuranceTopSection
                    insuranceLandingData={insuranceLandingData}
                    huddleBenefits={insuranceLandingData?.huddleBenefits || {}}
                    insurancePurchasedData={insurancePurchasedData}
                    insuranceDetailsData={insuranceDetailsData}
                    notPurchasedInsuranceData={notPurchasedInsuranceData}
                    purchasedInsuranceData={purchasedInsuranceData}
                    isInsurancePurchased={isInsurancePurchased}
                    isInsuranceSubmitted={isInsuranceSubmitted}
                    isInsuranceFailed={isInsuranceFailed}
                    huddleStatus={huddleStatus}
                    isInsuranceInitiated={isInsuranceInitiated}
                    formData={insuranceDetailsData}
                />
                {(isInsuranceInitiated || isInsuranceFailed) && (
                    <React.Fragment>
                        <div styleName="styles.secondSectionWrap">
                            {huddleUSPs.map((benefit, index) => (
                                <CarHuddleInsuranceSecondFoldCard
                                    key={index}
                                    cardIcon={benefit.iconUrl}
                                    heading={benefit.text}
                                    subHeading={benefit.subtext}
                                />
                            ))}
                        </div>
                        <div styleName="styles.howItWorksWrap">
                            <CarHuddleInsuranceHowItWorks
                                pendingQuestionsStepsData={pendingQuestionsStepsData}
                                completedQuestionsStepsData={completedQuestionsStepsData}
                                isInsuranceSubmitted={isInsuranceSubmitted || isInsuranceFailed}
                            />
                        </div>
                    </React.Fragment>
                )}
                <React.Fragment>
                    <div styleName="styles.customerCareWrap">
                        <CarHuddleInsuranceReviewRatingCard reviewData={reviewData} />
                    </div>
                </React.Fragment>
                {(isInsurancePurchased || isInsuranceSubmitted) && (
                    <React.Fragment>
                        {/* <div styleName="styles.congratsRatingOuter">
                            <CarHuddleInsuranceReviewRatingCard reviewData={reviewData} />
                        </div> */}
                        <div styleName="styles.customerCareWrap">
                            <CarHuddleInsuranceCustomerCare contactUs={contactUs} />
                        </div>
                    </React.Fragment>
                )}
            </div>

            {(isInsuranceInitiated || isInsuranceFailed) ? (
                <div styleName="styles.bottomWrapper">
                    <Button
                        onClick={generateQuotes}
                        text="Generate quote"
                        showArrow={true}
                        customStyle={["inter-btn-design"]}
                    />
                    <a href="#" onClick={() => onSkipClick(false)}>
                        I don’t want car insurance
                    </a>
                </div>

            ) : (
                <div styleName="styles.bottomWrapper">
                    <Button
                        onClick={() => onSkipClick(true)}
                        text="Proceed to my tasks"
                        showArrow={true}
                        customStyle={["inter-btn-design"]}
                    />
                </div>
            )}
            {isModalOpen && (
                <InsuranceCongratulationScreen
                    isOpen={isModalOpen}
                    cmsConfig={cmsConfig}
                    formData={insuranceDetailsData}
                    appointmentId={appointmentId}
                    setIsOpen={setIsModalOpen}
                    isSubmitLoading={isInsuranceLoading}
                />
            )}
        </div>
    );
};

CarInsurance.propTypes = {
    appointmentId: PropTypes.string,
    orderId: PropTypes.string,
    getInsuranceCmsConfigConnect: PropTypes.func,
    financeProvider: PropTypes.string,
    insuranceDetails: PropTypes.object,
    getInsuranceDetailsConnect: PropTypes.func,
    updatePostBcStepConnect: PropTypes.func,
    submitInsuranceDetailsConnect: PropTypes.func,
    cmsConfig: PropTypes.object
};

export default CarInsurance;
